import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DuplicatePersonTable from "../../Presentational/DuplicatePerson/DuplicatePersonTable";
const searchArgs = {
    merged: false,
    ignored: false,
    personA_IsMergeable: false,
    personB_IsMergeable: false,
};
const DuplicatePersonUnmergeableTab = ({ id, counterState, }) => {
    return (_jsx(DuplicatePersonTable, { search: Object.assign(Object.assign({}, searchArgs), { ruleSetIds: [id] }), noTableCheckboxes: true, noReviewAndMergeAllowed: true, counterState: counterState }));
};
export default DuplicatePersonUnmergeableTab;
